import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ApolloClient } from '@apollo/client';

import { SentMessage } from '../messages';

export interface Props extends RouteComponentProps<any> {
  client: ApolloClient<any>;
}

const SentMessagePage: React.FunctionComponent<Props> = ({
  match: {
    params: { emailId, orgId },
  },
}) => (
  <div id="messages" className="container hub-full-width">
    <div className="page-content u-xs-padXl u-flexExpandSides">
      <SentMessage emailId={emailId} orgId={+orgId} />
    </div>
  </div>
);

export default SentMessagePage;
